import React from 'react';

import './search-facets.scss';

import CrossSmallIcon from '../../../assets/icons/cross-small.svg';

const SearchFacets = ({ dataPillboxes, reset, onDelete, notCrossed, handleChoice }) => {
  const renderFacetsData = () => {
    if (handleChoice) {
      return dataPillboxes.map(({ id, label, active }) => {
        return (
          <button
            type="button"
            className={`search-facet ${active ? 'active-facet' : ''}`}
            key={id}
            onClick={() => handleChoice(id)}
            id="button">
            <span htmlFor="button" className={notCrossed ? 'not-crossed' : undefined}>
              {label}
            </span>
          </button>
        );
      });
    }
    return dataPillboxes.map((dataPillbox, index) => {
      const { id } = dataPillbox;
      return (
        <button
          type="button"
          className="search-facet"
          key={id || index}
          onClick={() => (onDelete ? onDelete(index) : () => {})}>
          <span className={notCrossed ? 'not-crossed' : undefined}>{dataPillbox}</span>
          {onDelete && (
            <span className="icon">
              <CrossSmallIcon />
            </span>
          )}
        </button>
      );
    });
  };

  return (
    <div className="search-facets">
      <div className="search-facets-pillboxes">{renderFacetsData()}</div>
      {reset && (
        <div className="search-facets-actions">
          <button className="button-icontrigger noborder" onClick={() => reset()}>
            <span className="icon">
              <CrossSmallIcon />
            </span>
            <span>Сбросить</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchFacets;
